
import React from 'react';
import { FlowRender } from "../flow-render";
import { Text, dollarValidator } from "../prm/text";
import { RadioButton, RADIO_SINGLE_RANDOM_VALUE } from "../prm/radio-button";
import { OptionMenu } from "../prm/option-menu";
import { Name } from "../prm/name";
import { AllNames } from "./shared-prms";
import {is_transfer as is_transfer_f, is_ira_rollover, is_ira} from "../onboarding-utils";
import faker from 'faker';
import {dollarToString, price_string_to_dollars} from "../currency-utils";
import { deep_copy } from "../js-utils";
import {render_recurring_payment} from "../onboarding-shared/widgets/recurring-payment";
import { InvestmentAccountType } from '../proto/investment_accounts';

const invest_start_amt = new Text(
  new Name(AllNames.invest_start_amt,
    "How much money would you like to start investing with?"));
invest_start_amt.setValidator(dollarValidator);

const contribute_yes_no = new RadioButton(
  new Name(AllNames.contribute_yes_no,
    "Do you want to contribute to your account on a regular basis?"),
  [
    new Name("yes", "Yes"),
    new Name("no", "No"),
  ], ["no"], RADIO_SINGLE_RANDOM_VALUE);

const contribute_cadence = new OptionMenu(
  new Name(AllNames.contribute_cadence, "How often"),
  [
    new Name("MONTHLY", "Monthly"),
    new Name("QUARTERLY", "Quarterly"),
    new Name("ANNUALLY", "Annually"),
  ]
);

const contribute_amt = new Text(
  new Name(AllNames.contribute_amt, "How much"));
contribute_amt.setValidator(dollarValidator);

const ACH_LIMIT_USD = 50000;

const cadenceValue = {
    'MONTHLY': 12,
    'QUARTERLY': 4,
    'ANNUALLY': 1
}

class Risk_2 extends FlowRender {

  constructor(index) {
    super(index, [
      invest_start_amt,
      contribute_yes_no,
      contribute_cadence,
      contribute_amt,
    ]);

    invest_start_amt.onChangeCallback = this.onChange;
    contribute_yes_no.onChangeCallback = this.onChange;
    contribute_cadence.onChangeCallback = this.onChange;
    contribute_amt.onChangeCallback = this.onChange;
    this.url = "risk_2";
    this.accountType = '';
    this.dateOfBirth = ''
;  }

  init(componentState, appState, component) {
    super.init(componentState, appState, component);
    invest_start_amt.setBlurValidator(this.amt_set(component));
    const onboarding = component.getOnboardingData(component.props);
    this.accountType = onboarding.account_type;
    this.dateOfBirth = onboarding.role_0_dob;
  }

  isIraAccount = (accountType) => {
    const { ira, roth_ira, rollover_ira, sepp_ira, simple_ira, custodial_ira} = InvestmentAccountType
    const iraAccountTypes = [ira.id, roth_ira.id, rollover_ira.id, sepp_ira.id, simple_ira.id, custodial_ira.id];
    const isIraAccount = iraAccountTypes.find(iraAcc => accountType === iraAcc);

    return isIraAccount;
  }

  amt_set = component => (start_amt_str) => {
    const start_amt = price_string_to_dollars(start_amt_str);
    if (start_amt > ACH_LIMIT_USD) {
      component.setState({ ach_limit_error: true });
    } else {
      component.setState({ ach_limit_error: false });
    }

    // only check if it is an IRA Account
    const isIraAccount = this.isIraAccount(this.accountType);
    if(!isIraAccount) return;

    const annualContributionLimit = this.getContributionLimit(this.dateOfBirth);
    if(start_amt >= annualContributionLimit) {
        component.setState({ overInvestmentLimit: true });
    } else {
        component.setState({ overInvestmentLimit: false });
    }

    component.setState({ investmentLimitError: false });
    return start_amt_str;
  }

  onChange = (component, newState) => {
    const start_blank = invest_start_amt.isBlank(newState);
    const yes_clicked = contribute_yes_no.isItemClicked(0, newState);
    const no_clicked = contribute_yes_no.isItemClicked(1, newState);
    const contrib_blank = contribute_amt.isBlank(newState);

    const do_endpoint = !start_blank && (
      no_clicked || (yes_clicked && !contrib_blank));

    newState.nextEndpoint = do_endpoint
      ? component.getRootUrl() + "/summary"
      : null;
  };

  setRandomValues(state, component) {
    super.setRandomValues(state);
    const dollars = faker.random.number({min: 10, max: 50, precision: 1 }) * 1000;
    invest_start_amt.setValue(state, dollarToString(dollars));

    if (contribute_yes_no.isItemClicked(0, state)) {
      contribute_cadence.setRandomValue(state);
      const contrib_dollars = faker.random.number({ min: 10, max: 200, precision: 10});
      contribute_amt.setValue(state, dollarToString(contrib_dollars));
    }
  }

  getContributionLimit(dateOfBirth) {
    const isOlderThanFifty = (dateStr) => {
        const [month, day, year] = dateStr.split("/").map(Number);
        const birthDate = new Date(year, month - 1, day); // JS months are 0-based
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();

        const hasHadBirthdayThisYear =
            today.getMonth() > birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

        if (!hasHadBirthdayThisYear) {
            age--;
        }

        return age >= 50;
    }

    // find way to get/update limit
    const postFiftyContributionLimit = 8000;
    const preFiftyContributionLimit = 7000;

    const contributionLimit = isOlderThanFifty(dateOfBirth) ? postFiftyContributionLimit : preFiftyContributionLimit;
    
    return contributionLimit;
  }



  canNavigateNext(component) {
    const state = component.state;
    if (state.ach_limit_error) {
      return null;
    }
    const highlight_rects = [];
    const onboarding = component.getOnboardingData(component.props);
    const is_transfer = is_transfer_f(onboarding);
    const check_funded = is_ira_rollover(onboarding);

    // check if empty
    const amt_filled = is_transfer || check_funded || invest_start_amt.isFilledElseHighlight(state, highlight_rects);
    const contrib_filled = contribute_yes_no.isFilledElseHighlight(state, highlight_rects);
    
    if (!amt_filled || !contrib_filled) {
      component.setState({ highlight_rects });
      return null;
    }

    const isIraAccount = this.isIraAccount(this.accountType);
    if(isIraAccount) {
        component.setState({ investmentLimitError: false });
        const annualContributionLimit = this.getContributionLimit(this.dateOfBirth);

        const investmentAmount = price_string_to_dollars(invest_start_amt.getValue(state));

        if(investmentAmount > annualContributionLimit) {
            component.setState({ investmentLimitError: true, annualContributionLimit })
            return null;
        }
    }
    
    const yes_clicked = contribute_yes_no.isItemClicked(0, state);
    if (yes_clicked) {
      if (!contribute_amt.isFilledElseHighlight(state, highlight_rects)) {
        component.setState({highlight_rects});
        return null;
      }

      const isIraAccount = this.isIraAccount(this.accountType);
      if(isIraAccount) {
        const annualContributionLimit = this.getContributionLimit(this.dateOfBirth);
        const investmentAmount = price_string_to_dollars(invest_start_amt.getValue(state));
        const remainingContribution = annualContributionLimit - investmentAmount;
        const cadence = cadenceValue[contribute_cadence.getValue(state).id];
        const maxContributionAmount = remainingContribution / cadence;
        const contributionAmount = price_string_to_dollars(contribute_amt.getValue(state));

        if(contributionAmount > maxContributionAmount) {
            component.setState({ overMaxContributionLimit: true, maxContributionLimit: maxContributionAmount })
            return null;
        } else {
            component.setState({ overMaxContributionLimit: false, maxContributionLimit: maxContributionAmount })
        }
        
      }

      // if greateher than ach limit max out at ach limit?
      const val = price_string_to_dollars(contribute_amt.getValue(state));
      if (val > ACH_LIMIT_USD) {
        const new_state = deep_copy(component.state);
        contribute_amt.setValue(new_state, dollarToString(ACH_LIMIT_USD));
        component.setState(new_state);
        return null;
      }
    }

    return component.getRootUrl() + "/crypto";
  }

  renderBody = component => {
    const input_style = {
      width: "15rem",
      textAlign: "center",
    };
    const ach_error_style = {
      margin: "0.2rem",
      color: "red",
      display: component.state.ach_limit_error ? "block" : "none",
    }

    const investmentLimitErrorStyle = {
        display: component.state.investmentLimitError ? "block" : "none",
        color: "red",
    }

    const onboarding = component.getOnboardingData(component.props);
    const is_transfer = is_transfer_f(onboarding);
    const check_funded = is_ira_rollover(onboarding);
    const show_initial_funding = !is_transfer && !check_funded;
    const show_ira_text = is_ira(onboarding);
    const ira_div = show_ira_text ? (
      <div style={{ marginTop: "1rem"}}>
        Your initial contribution as well as any regular
        contributions must be under the annual IRS contributions limits.
      </div>) : null;

    const contrib_style = {
      fontSize: show_initial_funding ? "1rem" : "1.5rem",
    }

    const cadence = contribute_cadence.getValue(component.state).label;
    

    // need to determine when to disable
    // also visibility message
    const contrib_div = (
      <fieldset disabled={component.state.overInvestmentLimit}>
        <div style={contrib_style}>{contribute_yes_no.name.label}</div>
        <div style={{ visibility: component.state.overInvestmentLimit ? 'visible' : 'hidden' }}>(You've hit the limit, no more needed)</div>
       
        { render_recurring_payment(
          component, contribute_yes_no, contribute_amt, contribute_cadence)}
        <div style={{ visibility: component.state.overMaxContributionLimit ? 'visible' : 'hidden', color: 'red' }}>
            You're over the {cadence.toLowerCase()} maximum contribution limit of {dollarToString(component.state.maxContributionLimit)}!
        </div>

      </fieldset>
    )

    return (
      <div>
        <div>
          { show_initial_funding && <div style={{fontSize: "1.5rem"}}>{invest_start_amt.name.label}</div> }
          { show_initial_funding && ira_div }
          <div style={{height: "1rem"}}/>
          { show_initial_funding && invest_start_amt.renderInput(component, input_style) }
          <div style={ach_error_style}>ACH limit is $50,000</div>
          <div style={investmentLimitErrorStyle}>This year's contribution cannot be over ${component.state.annualContributionLimit}.</div>
          <div style={{ height: "2rem"}}/>
        </div>
        { contrib_div }
        <div style={{height: "1rem"}}/>
      </div>
    )
  };

  render = component => {
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Account Funding", "50%", "952140573")}
        { this.renderProgress(component) }
        { this.renderSingleColumn(this.renderBody(component)) }
        { this.renderNextButtonRow(component, true) }
      </div>
    );
  }
}

export { Risk_2, invest_start_amt, contribute_yes_no, contribute_cadence,
  contribute_amt };
